import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How do you define a 'Moondos' brand identity?",
  answer: "We create cinematic identities that resonate. Through deep strategy and visual storytelling, we build brands that don't just exist—they lead their industry with authority, prestige, and a distinct creative edge."
}, {
  question: "What is your process for content creation?",
  answer: "Our process is visually driven and strategically anchored. We blend high-end cinematography with data-backed distribution to ensure your content captures attention and drives measurable growth across modern platforms."
}, {
  question: "Do you work with individual athletes and influencers?",
  answer: "Absolutely. Personal branding is one of our core pillars. We help high-profile individuals translate their physical or social influence into a premium digital legacy that appeals to high-end sponsors and global audiences."
}, {
  question: "How long does a typical website development project take?",
  answer: "1-2 weeks"
}, {
  question: "Can you manage my entire social media presence?",
  answer: "Yes. We offer comprehensive management including content strategy, high-fidelity creation, posting schedules, and community engagement. We act as your internal media department so you can focus on your craft."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="2752" id="frequently-asked-questions" className="relative w-full overflow-hidden bg-background py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-[600px] w-[600px] -translate-x-1/2 -translate-y-1/2 opacity-10">
        <div className="h-full w-full rounded-full bg-secondary blur-[160px]" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="col-span-1 lg:col-start-3 lg:col-span-8">
            <div className="mb-12 text-center">
              <h2 className="text-4xl font-black tracking-tighter text-foreground sm:text-6xl uppercase">
                Frequently Asked Questions
              </h2>
              <p className="mt-4 text-xl font-light tracking-wide text-muted-foreground">
                Insights into our process, strategy, and digital elevation.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full space-y-2">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-white/10 px-2">
                  <AccordionTrigger className="group py-8 text-left hover:no-underline [&>svg:last-child]:hidden">
                    <span className="flex-1 font-sans text-[22px] font-bold tracking-tight text-foreground transition-colors duration-300 group-data-[state=open]:text-secondary">
                      {faq.question}
                    </span>
                    <span className="relative flex size-10 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/5 transition-all duration-300 group-hover:border-secondary/50 group-hover:bg-secondary/10">
                      <Plus className="size-6 text-foreground transition-transform duration-300 group-data-[state=open]:rotate-45 group-hover:text-secondary group-hover:drop-shadow-[0_0_12px_var(--color-secondary)]" />
                    </span>
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="animate-in fade-in slide-in-from-bottom-2 pb-8 pt-2 text-lg font-light leading-relaxed text-muted-foreground duration-500">
                      {faq.answer}
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}